export const escapeHtml = (unsafe = '') => {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

export const afterSanitizeAttributes = currentNode => {
  if ('target' in currentNode) {
    currentNode.setAttribute('target', '_blank');
  }
};

export const domPurifyConfig = {
  hooks: {
    afterSanitizeAttributes,
  },
};

// ---- Complaint description profile ----
// DOMPurify cannot filter *style values* declaratively (ALLOWED_ATTR only
// whitelists the attribute name, not its contents). So for complaint
// descriptions we whitelist a small rich-text tag/attr set and additionally
// scrub the `style` attribute down to a single allowed `text-align` rule.
//
// IMPORTANT scoping note: vue-dompurify-html registers `hooks` GLOBALLY via
// DOMPurify.addHook (it only reads `hooks` from the TOP-LEVEL plugin options,
// not from a named config), and a `hooks` key inside a config passed to
// DOMPurify.sanitize is ignored by DOMPurify itself. A global
// uponSanitizeAttribute hook would therefore also run for the DEFAULT profile.
// To keep it harmless to every other profile we (a) only touch the `style`
// attribute, and (b) gate the behaviour on a marker key that we stamp onto
// THIS config object. DOMPurify clones the active config and passes it as the
// 3rd hook argument, so the marker is visible only when sanitizing with the
// complaint profile.
export const COMPLAINT_PROFILE_MARKER = '__complaintDescriptionProfile';

const TEXT_ALIGN_RE = /text-align\s*:\s*(left|center|right|justify)/i;

// Hook callback (register once, globally, in dashboard.js). It is a no-op
// unless the active config carries our marker AND the attribute is `style`.
// When active, it keeps ONLY a `text-align: left|center|right|justify`
// declaration and drops everything else (removing the attribute entirely when
// no valid alignment is present).
export const scrubComplaintStyleAttribute = (node, data, config) => {
  if (!config || !config[COMPLAINT_PROFILE_MARKER]) return;
  if (data.attrName !== 'style') return;
  const match = TEXT_ALIGN_RE.exec(data.attrValue || '');
  if (match) {
    data.attrValue = `text-align: ${match[1].toLowerCase()}`;
  } else {
    data.attrValue = '';
    data.keepAttr = false;
  }
};

export const complaintDomPurifyConfig = {
  [COMPLAINT_PROFILE_MARKER]: true,
  ALLOWED_TAGS: [
    'p',
    'br',
    'strong',
    'b',
    'em',
    'i',
    'u',
    'ul',
    'ol',
    'li',
    'blockquote',
    'h1',
    'h2',
    'h3',
    'a',
    'img',
    'span',
  ],
  ALLOWED_ATTR: ['href', 'target', 'src', 'alt', 'style', 'class'],
};
